import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ModalComponent } from './modal.component';
import { ButtonModule } from '@common/components/ButtonComponent/button.module';

@NgModule({
  declarations: [
    ModalComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    ButtonModule,
  ],
  exports: [
    ModalComponent,
  ],
  providers: [],
})
export class ModalModule { }



// WEBPACK FOOTER //
// ./src/app/common/components/ModalComponent/modal.module.ts